import React from 'react';

import withShimmerLoading from '../Wrappers/withShimmerLoading';

export const ShimmerDiv = withShimmerLoading(props => <div {...props} />);
export const ShimmerSpan = withShimmerLoading(props => <span {...props} />);
